module.exports = __webpack_public_path__ + "static/month-ad606037bda8849824ef5c888f01b72d.png";